import initialState from 'redux/initialState';
import actionTypes from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

import { TradingOfferOperation } from 'types/TradingOfferOperation';

type TradingOfferOperationAction = {
  type: string;
  tradingOfferOperations?: TradingOfferOperation[];
  tradingOfferOperation?: TradingOfferOperation;
  tradingOfferOperationId?: string;
};

const resetStateSociety = () => initialState.tradingOfferOperations;

const getTradingOfferOperations = (action: TradingOfferOperationAction) =>
  action.tradingOfferOperations;

const createTradingOfferOperation = (
  tradingOfferOperations: TradingOfferOperation[],
  action: TradingOfferOperationAction
) => [action.tradingOfferOperation, ...tradingOfferOperations];

const updateTradingOfferOperation = (
  tradingOfferOperations: TradingOfferOperation[],
  action: TradingOfferOperationAction
) =>
  tradingOfferOperations?.map((operation: TradingOfferOperation) =>
    operation._id === action?.tradingOfferOperation?._id
      ? action.tradingOfferOperation
      : operation
  );

const deleteTradingOfferOperation = (
  tradingOfferOperations: TradingOfferOperation[],
  action: TradingOfferOperationAction
) =>
  tradingOfferOperations?.filter(
    (operation: TradingOfferOperation) =>
      operation._id !== action.tradingOfferOperationId
  );

export default function reducer(
  tradingOfferOperations = initialState.tradingOfferOperations,
  action: TradingOfferOperationAction
) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case actionTypes.GET_TRADING_OFFER_OPERATIONS:
      return getTradingOfferOperations(action);

    case actionTypes.CREATE_TRADING_OFFER_OPERATION:
      return createTradingOfferOperation(tradingOfferOperations, action);

    case actionTypes.UPDATE_TRADING_OFFER_OPERATION:
      return updateTradingOfferOperation(tradingOfferOperations, action);

    case actionTypes.DELETE_TRADING_OFFER_OPERATION:
      return deleteTradingOfferOperation(tradingOfferOperations, action);

    default:
      return tradingOfferOperations;
  }
}
